import React from 'react';
  import { Modal, Box, IconButton, Typography } from '@mui/material';
  import CloseIcon from '@mui/icons-material/Close';
  import VideoPlayer from './VideoPlayer';

  const VideoModal = ({ isOpen, onClose, streamUrl, channelId }) => {
      const modalStyle = {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          outline: 'none',
          maxWidth: '90vw',
          maxHeight: '90vh',
          overflow: 'auto'
      };

      return (
          <Modal
              open={isOpen}
              onClose={onClose}
              aria-labelledby="video-modal-title"
              aria-describedby="video-modal-description"
          >
              <Box sx={modalStyle}>
                  {/* Modal Header */}
                  <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center',
                      mb: 2
                  }}>
                      <Typography id="video-modal-title" variant="h6" component="h2">
                          Live Stream - {channelId}
                      </Typography>
                      <IconButton 
                          onClick={onClose}
                          aria-label="close"
                          sx={{ ml: 2 }}
                      >
                          <CloseIcon />
                      </IconButton>
                  </Box>

                  {/* Video Player */}
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <VideoPlayer 
                          streamUrl={streamUrl} 
                          channelId={channelId}
                          width={640}
                          height={360}
                      />
                  </Box>

                  {/* Optional: Stream URL display */}
                  {streamUrl && (
                      <Box sx={{ mt: 2 }}>
                          <Typography variant="caption" color="text.secondary">
                              Stream URL: {streamUrl}
                          </Typography>
                      </Box>
                  )}
              </Box>
          </Modal>
      );
  };

export default VideoModal;
